export class CashRegisterControlTapeLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
} 